import ApprovalService from "./approvalService";
import RefundApprovalType from "../entities/refundApprovalType";
import Approvable from "../entities/approvable";
import { bound } from "@frui.ts/helpers";

export default class RefundsApprovalService extends ApprovalService<RefundApprovalType, Approvable> {
  @bound
  isApprovalProcessComplete(approvable: Approvable) {
    const approvals = approvable.approvals.flatMap(approval => approval.approvalType);

    return (
      approvals.includes(RefundApprovalType.FactualAuditor) &&
      approvals.includes(RefundApprovalType.CommandOperator) &&
      approvals.includes(RefundApprovalType.ChiefAccountant)
    );
  }

  @bound
  currentApproverPredecessor() {
    switch (this.whoAmI()) {
      case RefundApprovalType.ChiefAccountant:
        return RefundApprovalType.CommandOperator;
      case RefundApprovalType.CommandOperator:
        return RefundApprovalType.FactualAuditor;
      case RefundApprovalType.FactualAuditor:
      default:
        return undefined;
    }
  }

  protected isCurrentStepReadyOrDoneForFactualAuditor(approvals: RefundApprovalType[]) {
    return approvals.length === 0 || (approvals.length === 1 && approvals[0] === RefundApprovalType.FactualAuditor);
  }

  protected isCurrentStepReadyOrDoneForCommandOperator(approvals: RefundApprovalType[]) {
    return (
      (approvals.length === 1 && approvals.includes(RefundApprovalType.FactualAuditor)) ||
      (approvals.length === 2 &&
        approvals.includes(RefundApprovalType.FactualAuditor) &&
        approvals.includes(RefundApprovalType.CommandOperator))
    );
  }

  protected isCurrentStepReadyOrDoneForChiefAccountant(approvals: RefundApprovalType[]) {
    return (
      (approvals.length === 2 &&
        approvals.includes(RefundApprovalType.FactualAuditor) &&
        approvals.includes(RefundApprovalType.CommandOperator)) ||
      (approvals.length === 3 &&
        approvals.includes(RefundApprovalType.FactualAuditor) &&
        approvals.includes(RefundApprovalType.CommandOperator) &&
        approvals.includes(RefundApprovalType.ChiefAccountant))
    );
  }
}
